import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/** Centred spinner for a page or section that is loading. `fullPage` fills the screen. */
export const LoadingState = ({ fullPage = false, label }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      py: 6,
      minHeight: fullPage ? '100vh' : undefined,
      bgcolor: fullPage ? 'background.default' : undefined,
    }}
  >
    <CircularProgress />
    {label && (
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {label}
      </Typography>
    )}
  </Box>
);

/** Message shown when a list or table has nothing in it. */
export const EmptyState = ({ icon, title, children, action }) => (
  <Box sx={{ textAlign: 'center', py: 6, px: 2, color: 'text.secondary' }}>
    {icon && <Box sx={{ mb: 1, color: 'text.secondary', '& svg': { fontSize: 40 } }}>{icon}</Box>}
    {title && (
      <Typography variant="subtitle1" sx={{ color: 'text.primary' }}>
        {title}
      </Typography>
    )}
    {children && <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>{children}</Typography>}
    {action && <Box sx={{ mt: 2 }}>{action}</Box>}
  </Box>
);
